module.exports = __webpack_public_path__ + "static/media/Group 1094.930adf62.svg";